import { createContext, useCallback, useMemo, useState, FC } from 'react';

import ProjectFolderTreeModal, { ProjectFolderTreeModalProps } from '../../ProjectFolderTreeModal';

type Context = {
  isFolderTreeModal: boolean;
  openFolderTree: (params: ProjectFolderTreeModalProps) => void;
  closeFolderTree: () => void;
};

export const ProjectFolderTreeModalContext = createContext({} as Context);

const ProjectFolderTreeModalProvider: FC = ({ children }) => {
  const [folderTreeProps, setFolderTreeProps] = useState<ProjectFolderTreeModalProps | null>(null);

  const closeFolderTree = useCallback(() => {
    folderTreeProps?.onClose?.();
    setFolderTreeProps(null);
  }, []);

  const openFolderTree = (props: ProjectFolderTreeModalProps) => setFolderTreeProps(props);
  const isFolderTreeModal = !!folderTreeProps;

  const controls = useMemo(
    () => ({
      openFolderTree,
      closeFolderTree,
      isFolderTreeModal
    }),
    [isFolderTreeModal]
  );

  return (
    <ProjectFolderTreeModalContext.Provider value={controls}>
      {folderTreeProps && <ProjectFolderTreeModal {...folderTreeProps} onClose={closeFolderTree} />}
      {children}
    </ProjectFolderTreeModalContext.Provider>
  );
};

export default ProjectFolderTreeModalProvider;
